export default __webpack_public_path__ + "assets/c985289cac235aceb62cbba656cf540e.jpg";